import * as React from "react";
import { makeStyles } from "@material-ui/core";
import classnames from "classnames";

import { size, lineHeight, fontFamily, fontFamilySans, weight } from "@styles/type.styles";
import { headerColor } from "@styles/color.styles";
import { greys } from "@styles/color.styles";
import { IIntegerDataPoint } from "../overview.types";

export interface ChartProps {
  title: React.ReactNode;
  subtitle: React.ReactNode;
  chart: React.ReactNode;
}

export interface TimeSeriesProps {
  name: string;
  data: IIntegerDataPoint[];
  threshold?: number | null;
}

export interface ChartTooltipProps {
  valueSuffix?: string;
  xDataFormat?: string;
}

export const useStyles = makeStyles({
  container: {
    marginTop: 40,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  title: {
    fontFamily,
    fontSize: 21,
    fontWeight: "bold",
    lineHeight: lineHeight.std,
    marginBottom: ".5rem",
    color: headerColor,
  },
  subtitle: {
    fontFamily: fontFamilySans,
    fontSize: size.md,
    lineHeight: lineHeight.std,
    marginBottom: 40,
    color: greys.slate,
    fontWeight: weight.std,
  },
  chartWrapper: {
    marginLeft: 24,
  },
});

export const Chart = ({ title, subtitle, chart }: ChartProps) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div>
        <div className={classes.title}>{title}</div>
        <div className={classes.subtitle}>{subtitle}</div>
      </div>
      <div className={classnames(classes.chartWrapper, "chromatic-ignore")}>{chart}</div>
    </div>
  );
};
